(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ilan-detay"] && !Shopify.designMode) return;
  try {
    
(function () {
  var mevcutIndex = 0;
  var mediaData = [];

  // Medya verisini slide'lardan topla (lightbox için)
  document.querySelectorAll('#ilanSwiperAna .swiper-slide').forEach(function (slide, i) {
    var img = slide.querySelector('img');
    var mv  = slide.querySelector('model-viewer');
    mediaData.push({
      tip:    mv ? 'model' : 'image',
      gorsel: img ? img.src : ''
    });
  });

  // ── SWIPER BAŞLAT ──
  var swiperThumb = null;
  var thumbEl = document.getElementById('ilanSwiperThumb');
  if (thumbEl) {
    swiperThumb = new Swiper('#ilanSwiperThumb', {
      spaceBetween: 5,
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesProgress: true
    });
  }

  var swiperAna = new Swiper('#ilanSwiperAna', {
    spaceBetween: 0,
    grabCursor: true,
    navigation: {
      nextEl: '.ip-galeri__nav--next',
      prevEl: '.ip-galeri__nav--prev'
    },
    thumbs: swiperThumb ? { swiper: swiperThumb } : undefined,
    on: {
      slideChange: function () {
        mevcutIndex = this.activeIndex;
        var sayac = document.getElementById('ilanSayacMevcut');
        if (sayac) sayac.textContent = mevcutIndex + 1;
      }
    }
  });

  // ── LIGHTBOX ──
  var lightbox  = document.getElementById('ilanLightbox');
  var lbGorsel  = document.getElementById('ilanLightboxGorsel');
  var lbSayac   = document.getElementById('ilanLightboxSayac');
  var zoomBtn   = document.getElementById('ilanZoomBtn');

  function lbAc(index) {
    var data = mediaData[index];
    if (!lightbox || !lbGorsel || !data || data.tip === 'model') return;
    mevcutIndex = index;
    lbGorsel.src = data.gorsel;
    lbSayac.textContent = (index + 1) + ' / ' + mediaData.length;
    lightbox.classList.add('acik');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function lbKapat() {
    lightbox.classList.remove('acik');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  function lbGit(yon) {
    var yeniIndex = (mevcutIndex + yon + mediaData.length) % mediaData.length;
    if (mediaData[yeniIndex] && mediaData[yeniIndex].tip === 'model') {
      yeniIndex = (yeniIndex + yon + mediaData.length) % mediaData.length;
    }
    lbGorsel.classList.add('gecis');
    setTimeout(function () {
      lbGorsel.src = mediaData[yeniIndex].gorsel;
      lbSayac.textContent = (yeniIndex + 1) + ' / ' + mediaData.length;
      lbGorsel.classList.remove('gecis');
      mevcutIndex = yeniIndex;
    }, 150);
  }

  // Ana görsele tıkla → lightbox aç
  document.querySelectorAll('#ilanSwiperAna .swiper-slide img').forEach(function (img) {
    img.addEventListener('click', function () { lbAc(mevcutIndex); });
  });
  if (zoomBtn) zoomBtn.addEventListener('click', function () { lbAc(mevcutIndex); });

  var lbKapatBtn = document.getElementById('ilanLightboxKapat');
  var lbSolBtn   = document.getElementById('ilanLightboxSol');
  var lbSagBtn   = document.getElementById('ilanLightboxSag');
  if (lbKapatBtn) lbKapatBtn.addEventListener('click', lbKapat);
  if (lbSolBtn)   lbSolBtn.addEventListener('click', function () { lbGit(-1); });
  if (lbSagBtn)   lbSagBtn.addEventListener('click', function () { lbGit(1); });
  if (lightbox)   lightbox.addEventListener('click', function (e) { if (e.target === lightbox) lbKapat(); });
  document.addEventListener('keydown', function (e) {
    if (!lightbox || !lightbox.classList.contains('acik')) return;
    if (e.key === 'Escape') lbKapat();
    if (e.key === 'ArrowLeft') lbGit(-1);
    if (e.key === 'ArrowRight') lbGit(1);
  });
  var lbTouchStart = 0;
  if (lbGorsel) {
    lbGorsel.addEventListener('touchstart', function (e) { lbTouchStart = e.touches[0].clientX; }, { passive: true });
    lbGorsel.addEventListener('touchend', function (e) {
      var d = lbTouchStart - e.changedTouches[0].clientX;
      if (Math.abs(d) > 50) lbGit(d > 0 ? 1 : -1);
    });
  }

  // ── LINK KOPYALA ──
  var toast     = document.getElementById('ilanToast');
  var toastTimer;
  var linkBtn   = document.getElementById('ilanLinkKopyala');

  function toastGoster() {
    clearTimeout(toastTimer);
    toast.classList.add('goster');
    toastTimer = setTimeout(function () { toast.classList.remove('goster'); }, 2500);
  }
  function kopyala() {
    var orig = linkBtn.innerHTML;
    linkBtn.classList.add('kopyalandi');
    linkBtn.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
    toastGoster();
    setTimeout(function () { linkBtn.classList.remove('kopyalandi'); linkBtn.innerHTML = orig; }, 2500);
  }
  function fallbackKopyala() {
    var ta = document.createElement('textarea');
    ta.value = window.location.href;
    ta.style.cssText = 'position:fixed;opacity:0;top:0;left:0;';
    document.body.appendChild(ta); ta.select(); document.execCommand('copy'); document.body.removeChild(ta);
  }
  if (linkBtn) {
    linkBtn.addEventListener('click', function () {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(window.location.href).then(kopyala).catch(function () { fallbackKopyala(); kopyala(); });
      } else { fallbackKopyala(); kopyala(); }
    });
  }

  // ── SEKMELER ──
  document.querySelectorAll('.ip-tab').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var hedef = this.dataset.sekme;
      document.querySelectorAll('.ip-tab').forEach(function (s) { s.classList.remove('aktif'); s.setAttribute('aria-selected', 'false'); });
      document.querySelectorAll('.ip-tab-panel').forEach(function (p) { p.classList.remove('aktif'); p.hidden = true; });
      this.classList.add('aktif'); this.setAttribute('aria-selected', 'true');
      var panel = document.getElementById('ilan-panel-' + hedef);
      if (panel) { panel.classList.add('aktif'); panel.hidden = false; }
    });
  });

  // ── DEVAMINI OKU ──
  var aciklamaEl  = document.getElementById('ilanAciklama');
  var fadeEl      = document.getElementById('ilanAciklamaFade');
  var devBtn      = document.getElementById('ilanDevaminiOku');
  var devBtnText  = devBtn ? devBtn.querySelector('.ip-devamini-oku__text') : null;
  if (aciklamaEl && devBtn) {
    if (aciklamaEl.scrollHeight <= 125) { devBtn.style.display = 'none'; if (fadeEl) fadeEl.style.display = 'none'; }
    devBtn.addEventListener('click', function () {
      var acik = aciklamaEl.classList.toggle('acik');
      devBtn.classList.toggle('acik', acik);
      if (fadeEl) fadeEl.classList.toggle('gizli', acik);
      if (devBtnText) devBtnText.textContent = acik ? 'Daha Az Göster' : 'Devamını Oku';
    });
  }

  // ── EKSPERTİZ SVG TOOLTIP ──
  document.querySelectorAll('.ip-exp-svg-inner').forEach(function (wrap) {
    var tip = wrap.querySelector('.ip-exp-tooltip');
    wrap.querySelectorAll('.ip-exp-parca').forEach(function (g) {
      var ad = g.dataset.ad;
      if (!ad || !tip) return;
      g.addEventListener('mouseenter', function () { tip.textContent = ad; tip.classList.add('goster'); });
      g.addEventListener('mousemove', function (e) {
        var r = wrap.getBoundingClientRect();
        tip.style.left = (e.clientX - r.left + 10) + 'px';
        tip.style.top  = (e.clientY - r.top - 28) + 'px';
      });
      g.addEventListener('mouseleave', function () { tip.classList.remove('goster'); });
    });
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ilan-liste"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* ── GÖRÜNÜM TOGGLE ── */
  var gridWrap = document.getElementById('ilGrid-wrap');
  var btnGrid  = document.getElementById('ilGrid');
  var btnListe = document.getElementById('ilListe');
  if (gridWrap && btnGrid && btnListe) {
    if (localStorage.getItem('ilGorunum') === 'liste') {
      gridWrap.classList.add('liste-mod');
      btnListe.classList.add('aktif');
      btnGrid.classList.remove('aktif');
    }
    btnGrid.addEventListener('click', function () {
      gridWrap.classList.remove('liste-mod');
      btnGrid.classList.add('aktif');
      btnListe.classList.remove('aktif');
      localStorage.setItem('ilGorunum', 'grid');
    });
    btnListe.addEventListener('click', function () {
      gridWrap.classList.add('liste-mod');
      btnListe.classList.add('aktif');
      btnGrid.classList.remove('aktif');
      localStorage.setItem('ilGorunum', 'liste');
    });
  }

  /* ── İLAN KARŞILAŞTIRMA ── */
  var KARS_KEY = 'mfKarsilastirma';
  var KARS_MAX = 4; // NOT: karsilastir-bar.liquid içindeki ilan limiti mantığıyla tutarlı olsun
  var KARS_EVENT = 'mf:karsilastirma-guncellendi';

  function karsListesiAl() {
    try { return JSON.parse(localStorage.getItem(KARS_KEY)) || []; }
    catch (e) { return []; }
  }
  function karsListesiYaz(liste) {
    localStorage.setItem(KARS_KEY, JSON.stringify(liste));
    document.dispatchEvent(new CustomEvent(KARS_EVENT));
  }
  function karsBtnDurumGuncelle(btn, aktif) {
    btn.classList.toggle('aktif', aktif);
    btn.setAttribute('aria-pressed', aktif ? 'true' : 'false');
    btn.title = aktif ? 'Karşılaştırmadan çıkar' : 'Karşılaştırmaya ekle';
  }
  function karsKartlariSenkronize() {
    var liste = karsListesiAl();
    document.querySelectorAll('.il-kart__kars-btn').forEach(function (btn) {
      var id = btn.getAttribute('data-id');
      karsBtnDurumGuncelle(btn, liste.some(function (u) { return u.id === id; }));
    });
  }
  karsKartlariSenkronize();
  document.addEventListener(KARS_EVENT, karsKartlariSenkronize);

  if (gridWrap) {
    gridWrap.addEventListener('click', function (e) {
      var btn = e.target.closest('.il-kart__kars-btn');
      if (!btn) return;
      e.preventDefault();

      var id = btn.getAttribute('data-id');
      var liste = karsListesiAl();
      var index = liste.findIndex(function (u) { return u.id === id; });

      if (index > -1) {
        liste.splice(index, 1);
        karsListesiYaz(liste);
      } else {
        if (liste.length >= KARS_MAX) {
          alert('En fazla ' + KARS_MAX + ' ilanı karşılaştırabilirsiniz. Önce listeden bir ilan çıkarın.');
          return;
        }
        liste.push({
          id: id,
          title: btn.getAttribute('data-title'),
          url: btn.getAttribute('data-url'),
          image: btn.getAttribute('data-image'),
          price: btn.getAttribute('data-price'),
          marka: btn.getAttribute('data-marka'),
          model: btn.getAttribute('data-model'),
          yil: btn.getAttribute('data-yil'),
          km: btn.getAttribute('data-km'),
          hacim: btn.getAttribute('data-hacim'),
          vites: btn.getAttribute('data-vites'),
          durum: btn.getAttribute('data-durum')
        });
        karsListesiYaz(liste);
      }
    });
  }

  /* ── FİLTRE PANELİ AÇ/KAPA ── */
  var toggleBtn = document.getElementById('ilFiltrePanelAc');
  var panel     = document.getElementById('ilFiltrePaneli');
  if (toggleBtn && panel) {
    toggleBtn.addEventListener('click', function () {
      var acik = panel.classList.toggle('acik');
      toggleBtn.setAttribute('aria-expanded', acik ? 'true' : 'false');
      panel.setAttribute('aria-hidden', acik ? 'false' : 'true');
    });
  }

  /* ── FİLTRE GRUP AÇ/KAPA ── */
  document.querySelectorAll('.il-filtre-grup__baslik').forEach(function (btn) {
    btn.setAttribute('aria-expanded', 'true');
    btn.addEventListener('click', function () {
      var govde = btn.nextElementSibling;
      if (!govde) return;
      var acik = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', acik ? 'false' : 'true');
      govde.classList.toggle('gizli', acik);
    });
  });

  /* ── "TÜMÜNÜ GÖSTER" ── */
  document.querySelectorAll('.il-filtre-daha').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var liste = btn.previousElementSibling;
      if (liste && liste.classList.contains('il-filtre-liste--uzun')) {
        liste.style.maxHeight = liste.style.maxHeight ? '' : liste.scrollHeight + 'px';
        btn.textContent = liste.style.maxHeight ? 'Daha Az Göster' : 'Tümünü Göster (' + liste.querySelectorAll('.il-filtre-secim').length + ')';
      }
    });
  });

  /* ── FİLTRE FORM SUBMIT (URL'e dönüştür) ── */
  var form = document.getElementById('ilFiltreForum');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var params = new URLSearchParams();

      /* Checkbox'lar: name attribute'u Liquid'den GERÇEK param_name olarak geliyor
         (örn. filter.v.option.marka). Buraya ekstra "filter." prefix EKLEME — eklenirse
         filter.filter.v.option.marka gibi geçersiz bir parametre oluşur ve Shopify
         bunu tanımadığı için filtre hiç uygulanmaz. Bu, "filtre çalışmıyor" sorununun
         asıl sebebiydi. */
      form.querySelectorAll('input[type="checkbox"]:checked').forEach(function (cb) {
        params.append(cb.name, cb.value);
      });

      /* Fiyat inputları: name'leri zaten filtre.min_value.param_name / max_value.param_name
         olarak geliyor, kuruşa çevirip (x100) ekliyoruz. */
      form.querySelectorAll('input[type="number"]').forEach(function (inp) {
        var val = inp.value.trim();
        if (val !== '' && !isNaN(parseFloat(val))) {
          params.append(inp.name, Math.round(parseFloat(val) * 100).toString());
        }
      });

      var sortEl = form.querySelector('input[name="sort_by"]');
      if (sortEl && sortEl.value) params.set('sort_by', sortEl.value);

      window.location.href = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    });
  }
  /* ── SONSUZ KAYDIRMA (Infinite Scroll) ── */
  var ilGrid = document.getElementById('ilGrid-wrap');
  var sayfalamaBolge = document.getElementById('ilSayfalamaBolge');
  var sentinel = document.getElementById('ilScrollSentinel');
  var loader = document.getElementById('ilScrollLoader');

  if (ilGrid && sayfalamaBolge && sentinel && loader && ilGrid.getAttribute('data-sonsuz') === 'true') {
    var sectionId = ilGrid.getAttribute('data-section-id');
    var yukleniyor = false;
    var bitti = false;

    sayfalamaBolge.classList.add('il-sayfalama-bolge--gizli');

    var ilYukleDahaFazla = function () {
      var nextUrl = sayfalamaBolge.getAttribute('data-next-url');
      if (!nextUrl || yukleniyor || bitti) return;
      yukleniyor = true;
      loader.hidden = false;

      var ayrac = nextUrl.indexOf('?') > -1 ? '&' : '?';
      fetch(nextUrl + ayrac + 'section_id=' + sectionId)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var dom = new DOMParser().parseFromString(html, 'text/html');
          var yeniGrid = dom.getElementById('ilGrid-wrap');
          if (yeniGrid) {
            yeniGrid.querySelectorAll('.il-kart').forEach(function (kart) {
              ilGrid.appendChild(kart);
            });
            karsKartlariSenkronize();
          }
          var yeniBolge = dom.getElementById('ilSayfalamaBolge');
          var yeniNext = yeniBolge ? yeniBolge.getAttribute('data-next-url') : '';
          if (yeniNext) {
            sayfalamaBolge.setAttribute('data-next-url', yeniNext);
          } else {
            bitti = true;
            gozlemci.disconnect();
          }
        })
        .catch(function () {
          /* hata olursa bir dahaki kaydırmada tekrar denenir */
        })
        .finally(function () {
          yukleniyor = false;
          loader.hidden = true;
        });
    };

    var gozlemci = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) ilYukleDahaFazla();
      });
    }, { rootMargin: '600px 0px 0px 0px' });

    gozlemci.observe(sentinel);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["karsilastir-bar"]) return;
  try {
    
(function () {
  var KARS_KEY = 'mfKarsilastirma';
  var KARS_EVENT = 'mf:karsilastirma-guncellendi';

  function karsListesiAl() {
    try { return JSON.parse(localStorage.getItem(KARS_KEY)) || []; }
    catch (e) { return []; }
  }
  function karsListesiYaz(liste) {
    localStorage.setItem(KARS_KEY, JSON.stringify(liste));
    document.dispatchEvent(new CustomEvent(KARS_EVENT));
  }

  var cubuk = document.getElementById('kbCubuk');
  var sayac = document.getElementById('kbSayac');
  var thumblar = document.getElementById('kbThumblar');
  var temizleBtn = document.getElementById('kbTemizle');
  var karsBtn = document.getElementById('kbKarsilastirBtn');
  var overlay = document.getElementById('kmOverlay');
  var govde = document.getElementById('kmGovde');
  var kapatBtn = document.getElementById('kmKapat');

  if (!cubuk) return; /* section.settings.aktif kapalıysa hiçbir şey çalıştırma */

  function thumbOlustur(urun) {
    var div = document.createElement('div');
    div.className = 'kb-thumb';

    var img = document.createElement('img');
    img.src = urun.image || '';
    img.alt = '';
    img.className = 'kb-thumb__img';
    img.onerror = function () { this.style.visibility = 'hidden'; };

    var ad = document.createElement('span');
    ad.className = 'kb-thumb__ad';
    ad.textContent = [urun.marka, urun.model].filter(Boolean).join(' ') || urun.title || '';

    var sil = document.createElement('button');
    sil.type = 'button';
    sil.className = 'kb-thumb__sil';
    sil.setAttribute('data-id', urun.id);
    sil.setAttribute('aria-label', 'Kaldır');
    sil.innerHTML = '<svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';

    div.appendChild(img);
    div.appendChild(ad);
    div.appendChild(sil);
    return div;
  }

  function cubuguRenderEt() {
    var liste = karsListesiAl();

    if (liste.length === 0) {
      cubuk.classList.remove('gorunur');
      setTimeout(function () {
        if (karsListesiAl().length === 0) cubuk.hidden = true;
      }, 300);
      return;
    }

    cubuk.hidden = false;
    requestAnimationFrame(function () { cubuk.classList.add('gorunur'); });

    sayac.textContent = liste.length;
    thumblar.innerHTML = '';
    liste.forEach(function (urun) {
      thumblar.appendChild(thumbOlustur(urun));
    });

    karsBtn.disabled = liste.length < 2;
  }

  function tabloOlustur(liste) {
    var specler = [
      { ad: 'Fiyat', anahtar: 'price', oncelik: true },
      { ad: 'Marka', anahtar: 'marka' },
      { ad: 'Model', anahtar: 'model' },
      { ad: 'Yıl', anahtar: 'yil' },
      { ad: 'Kilometre', anahtar: 'km' },
      { ad: 'Motor Hacmi', anahtar: 'hacim' },
      { ad: 'Vites', anahtar: 'vites' },
      { ad: 'Durum', anahtar: 'durum' }
    ];

    var sarmalayici = document.createElement('div');
    sarmalayici.className = 'km-tablo-wrap';

    var tablo = document.createElement('table');
    tablo.className = 'km-tablo';

    var thead = document.createElement('thead');
    var basRow = document.createElement('tr');
    basRow.appendChild(document.createElement('th'));

    liste.forEach(function (urun) {
      var th = document.createElement('th');
      th.className = 'km-urun-baslik';

      var sil = document.createElement('button');
      sil.type = 'button';
      sil.className = 'km-urun-sil';
      sil.setAttribute('data-id', urun.id);
      sil.setAttribute('aria-label', 'Karşılaştırmadan çıkar');
      sil.innerHTML = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';

      var img = document.createElement('img');
      img.src = urun.image || '';
      img.alt = '';
      img.className = 'km-urun-gorsel';
      img.onerror = function () { this.style.visibility = 'hidden'; };

      var baglanti = document.createElement('a');
      baglanti.href = urun.url || '#';
      baglanti.className = 'km-urun-link';
      baglanti.textContent = urun.title || '';

      th.appendChild(sil);
      th.appendChild(img);
      th.appendChild(baglanti);
      basRow.appendChild(th);
    });
    thead.appendChild(basRow);
    tablo.appendChild(thead);

    var tbody = document.createElement('tbody');
    specler.forEach(function (spec) {
      var tr = document.createElement('tr');
      if (spec.oncelik) tr.className = 'km-satir-oncelik';

      var thLabel = document.createElement('th');
      thLabel.textContent = spec.ad;
      tr.appendChild(thLabel);

      liste.forEach(function (urun) {
        var td = document.createElement('td');
        td.textContent = urun[spec.anahtar] || '—';
        tr.appendChild(td);
      });
      tbody.appendChild(tr);
    });
    tablo.appendChild(tbody);

    sarmalayici.appendChild(tablo);
    return sarmalayici;
  }

  function modalAcVeDoldur() {
    var liste = karsListesiAl();
    if (liste.length === 0) return;
    govde.innerHTML = '';
    govde.appendChild(tabloOlustur(liste));
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function modalKapat() {
    overlay.hidden = true;
    document.body.style.overflow = '';
  }

  karsBtn.addEventListener('click', modalAcVeDoldur);
  kapatBtn.addEventListener('click', modalKapat);
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) modalKapat();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !overlay.hidden) modalKapat();
  });

  thumblar.addEventListener('click', function (e) {
    var btn = e.target.closest('.kb-thumb__sil');
    if (!btn) return;
    var id = btn.getAttribute('data-id');
    karsListesiYaz(karsListesiAl().filter(function (u) { return u.id !== id; }));
  });

  govde.addEventListener('click', function (e) {
    var btn = e.target.closest('.km-urun-sil');
    if (!btn) return;
    var id = btn.getAttribute('data-id');
    var liste = karsListesiAl().filter(function (u) { return u.id !== id; });
    karsListesiYaz(liste);
    if (liste.length === 0) {
      modalKapat();
    } else {
      modalAcVeDoldur();
    }
  });

  temizleBtn.addEventListener('click', function () {
    karsListesiYaz([]);
  });

  document.addEventListener(KARS_EVENT, cubuguRenderEt);
  window.addEventListener('storage', function (e) {
    if (e.key === KARS_KEY) cubuguRenderEt();
  });

  cubuguRenderEt();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rider-match"] && !Shopify.designMode) return;
  try {
    
(function () {
'use strict';

/* ════════════════ VERİ ════════════════ */
var URUNLER = [];
try {
  var jsonEl = document.getElementById('rmUrunlerJSON');
  if (jsonEl) URUNLER = JSON.parse(jsonEl.textContent || '[]');
} catch(e) { URUNLER = []; }

/* ════════════════ SVG İKONLAR ════════════════ */
var SVG = {
  deneyim:   '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>',
  tarz:      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>',
  artci:     '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>',
  butce:     '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>',
  motor:     '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="18" cy="18" r="3"/><circle cx="6" cy="18" r="3"/><path d="M8 18H3a1 1 0 0 1-1-1V9h10l3 3h2l2 2v3h-2"/><path d="M14 18h-4"/></svg>',
  hiz:       '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>',
  cc:        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v4l3 3"/></svg>',
  yil:       '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>',
  km:        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>',
  lokasyon:  '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>',
  telefon:   '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.62 3.39 2 2 0 0 1 3.6 1.21h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.8a16 16 0 0 0 6.29 6.29l.97-.97a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>',
  takas:     '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></svg>',
  vites:     '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="5" cy="6" r="3"/><circle cx="19" cy="6" r="3"/><circle cx="5" cy="18" r="3"/><line x1="19" y1="9" x2="19" y2="21"/><line x1="5" y1="9" x2="5" y2="15"/><line x1="5" y1="9" x2="19" y2="9"/></svg>',
  check:     '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>',
  chevron:   '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>',
  noResult:  '<svg width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="8" y1="11" x2="14" y2="11"/></svg>',
  sehir:     '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><rect x="3" y="9" width="5" height="12"/><rect x="10" y="3" width="5" height="18"/><rect x="17" y="6" width="5" height="15"/></svg>',
  uzunYol:   '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M3 12h18M3 12l4-4M3 12l4 4M21 12l-4-4M21 12l-4 4"/></svg>',
  haftasonu: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"/></svg>',
  adventure: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polygon points="3 17 12 3 21 17"/><line x1="3" y1="17" x2="21" y2="17"/></svg>',
  naked:     '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>',
  supersport:'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 19l7-16 7 16"/><path d="M8 13h8"/></svg>',
  touring:   '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>',
  cruiser:   '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/></svg>',
  scooter:   '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="6" cy="18" r="3"/><circle cx="18" cy="18" r="3"/><path d="M6 15h12V9l-4-4H6L3 9v6h3"/></svg>'
};

/* ════════════════ SORULAR ════════════════ */
var SORULAR = [
  {
    id: 'deneyim', tip: 'tek',
    metin: 'Sürüş deneyiminiz?',
    ipucu: 'Dürüst cevap daha doğru öneri sağlar.',
    kol: 1,
    secenekler: [
      { v: 'baslangic', ikonKey: 'motor',    etiket: 'Başlangıç',    alt: 'Yeni sürücü veya ehliyet yeni alındı' },
      { v: 'orta',      ikonKey: 'hiz',      etiket: 'Orta Seviye',  alt: '2–5 yıl deneyim, rahat sürüş' },
      { v: 'ileri',     ikonKey: 'deneyim',  etiket: 'İleri Seviye', alt: '5+ yıl, her koşulda güvenli' }
    ]
  },
  {
    id: 'kullanim', tip: 'cok',
    metin: 'Motoru en çok nerede kullanacaksınız?',
    ipucu: 'Birden fazla seçebilirsiniz.',
    kol: 2,
    secenekler: [
      { v: 'sehir',     ikonKey: 'sehir',     etiket: 'Şehir İçi',  alt: 'Trafik, kısa mesafe' },
      { v: 'uzun_yol',  ikonKey: 'uzunYol',   etiket: 'Uzun Yol',   alt: 'Otoyol, şehirlerarası' },
      { v: 'haftasonu', ikonKey: 'haftasonu', etiket: 'Hafta Sonu', alt: 'Keyif sürüşleri' },
      { v: 'touring',   ikonKey: 'touring',   etiket: 'Touring',    alt: 'Çok günlü turlar' },
      { v: 'adventure', ikonKey: 'adventure', etiket: 'Adventure',  alt: 'Asfalt + off-road' },
      { v: 'gundelik',  ikonKey: 'sehir',     etiket: 'Gündelik',   alt: 'Her gün, pratik' }
    ]
  },
  {
    id: 'tarz', tip: 'tek',
    metin: 'Sürüş tarzınız nasıl?',
    ipucu: 'Genellikle nasıl sürdüğünüzü seçin.',
    kol: 2,
    secenekler: [
      { v: 'konforlu', ikonKey: 'haftasonu', etiket: 'Konforlu', alt: 'Rahat, sakin sürüş' },
      { v: 'agresif',  ikonKey: 'hiz',       etiket: 'Agresif',  alt: 'Hızlı, dinamik' },
      { v: 'dengeli',  ikonKey: 'vites',     etiket: 'Dengeli',  alt: 'Duruma göre değişir' },
      { v: 'sportif',  ikonKey: 'supersport',etiket: 'Sportif',  alt: 'Performans öncelikli' }
    ]
  },
  {
    id: 'kategori', tip: 'cok',
    metin: 'Hangi kategorileri seviyorsunuz?',
    ipucu: 'Birden fazla seçebilirsiniz.',
    kol: 2,
    secenekler: [
      { v: 'Naked',      ikonKey: 'naked',      etiket: 'Naked',      alt: 'Açık, dikey pozisyon' },
      { v: 'Supersport', ikonKey: 'supersport', etiket: 'Supersport', alt: 'Yüksek performans' },
      { v: 'Adventure',  ikonKey: 'adventure',  etiket: 'Adventure',  alt: 'Her zemine uygun' },
      { v: 'Touring',    ikonKey: 'touring',    etiket: 'Touring',    alt: 'Uzun yol konforu' },
      { v: 'Cruiser',    ikonKey: 'cruiser',    etiket: 'Cruiser',    alt: 'Klasik ve karizmatik' },
      { v: 'Scooter',    ikonKey: 'scooter',    etiket: 'Scooter',    alt: 'Pratik şehir içi' }
    ]
  },
  {
    id: 'artci', tip: 'tek',
    metin: 'Artçı kullanıyor musunuz?',
    ipucu: 'Sele kapasitesi öneriye dahil edilir.',
    kol: 3,
    secenekler: [
      { v: 'hic',     ikonKey: 'motor',  etiket: 'Hiç',      alt: 'Sadece ben' },
      { v: 'arasira', ikonKey: 'artci',  etiket: 'Ara Sıra', alt: 'Bazen arkadaş' },
      { v: 'sik',     ikonKey: 'artci',  etiket: 'Sık Sık',  alt: 'Genellikle 2 kişi' }
    ]
  },
  {
    id: 'takas', tip: 'tek',
    metin: 'Takas yapmak ister misiniz?',
    ipucu: 'Stoğumuzda takas kabul eden ilanlar filtrelenir.',
    kol: 2,
    secenekler: [
      { v: 'evet',  ikonKey: 'takas', etiket: 'Evet, takas yaparım',   alt: 'Elindeki motoru getir' },
      { v: 'hayir', ikonKey: 'butce', etiket: 'Hayır, nakit alacağım', alt: 'Sadece nakit' }
    ]
  },
  {
    id: 'butce', tip: 'slider',
    metin: 'Bütçe aralığınız?',
    ipucu: 'Kaydırarak bütçenizi seçin.',
    min: 50000, max: 2000000, adim: 25000, varsayilan: 400000
  },
  {
    id: 'odeme', tip: 'tek',
    metin: 'Ödeme tercihiniz?',
    ipucu: 'Taksit seçenekleri filtrelenir.',
    kol: 3,
    secenekler: [
      { v: 'pesin',    ikonKey: 'butce', etiket: 'Peşin',     alt: 'Tek seferde' },
      { v: 'taksit6',  ikonKey: 'cc',    etiket: '6 Taksit',  alt: '6 aya bölünür' },
      { v: 'taksit12', ikonKey: 'cc',    etiket: '12 Taksit', alt: '12 aya bölünür' }
    ]
  }
];

/* ════════════════ SKOR ════════════════ */
function urunPuanla(urun, c) {
  var s = 50;
  var fiyat = urun.fiyat || 0;
  if (fiyat <= c.butce) {
    s += 20;
    var oran = fiyat / c.butce;
    if (oran >= 0.7 && oran <= 1.0) s += 10;
    else if (oran < 0.5) s -= 5;
  } else {
    var asim = (fiyat - c.butce) / c.butce;
    if (asim <= 0.15) s += 5;
    else s -= 30;
  }
  var urunKat = (urun.kategori || '').toLowerCase();
  if (c.kategori && c.kategori.length > 0) {
    var katEslesti = false;
    for (var i = 0; i < c.kategori.length; i++) {
      if (urunKat.indexOf(c.kategori[i].toLowerCase()) > -1) { katEslesti = true; break; }
    }
    if (katEslesti) s += 18; else s -= 8;
  }
  var kullanim = c.kullanim || [];
  if (includes(kullanim, 'sehir')) {
    if (urunKat.indexOf('naked') > -1 || urunKat.indexOf('scooter') > -1) s += 8;
  }
  if (includes(kullanim, 'uzun_yol') || includes(kullanim, 'touring')) {
    if (urunKat.indexOf('touring') > -1 || urunKat.indexOf('adventure') > -1) s += 10;
  }
  if (includes(kullanim, 'adventure')) {
    if (urunKat.indexOf('adventure') > -1) s += 12;
  }
  if (c.takas === 'evet' && urun.takas_olur === true) s += 12;
  else if (c.takas === 'evet' && urun.takas_olur !== true) s -= 8;
  if (c.odeme === 'taksit6'  && urun.taksit_6ay  && urun.taksit_6ay  !== '') s += 10;
  if (c.odeme === 'taksit12' && urun.taksit_12ay && urun.taksit_12ay !== '') s += 10;
  if (c.odeme === 'pesin'    && urun.tek_cekim   && urun.tek_cekim   !== '') s += 5;
  var hacim = parseInt(urun.motor_hacmi, 10) || 0;
  if (c.deneyim === 'baslangic') {
    if (hacim > 0 && hacim <= 400) s += 14;
    else if (hacim > 600) s -= 10;
  } else if (c.deneyim === 'orta') {
    if (hacim >= 300 && hacim <= 700) s += 10;
  } else if (c.deneyim === 'ileri') {
    if (hacim >= 600) s += 10;
  }
  if (c.tarz === 'sportif' || c.tarz === 'agresif') {
    if (urunKat.indexOf('supersport') > -1 || urunKat.indexOf('naked') > -1) s += 8;
  }
  if (c.tarz === 'konforlu') {
    if (urunKat.indexOf('touring') > -1 || urunKat.indexOf('cruiser') > -1) s += 8;
  }
  if (c.artci === 'sik') {
    if (urunKat.indexOf('touring') > -1 || urunKat.indexOf('adventure') > -1) s += 6;
  }
  if (urun.hasar_kayitsiz === true) s += 5;
  return Math.min(Math.max(Math.round(s), 0), 99);
}

/* ════════════════ YARDIMCI ════════════════ */
function includes(arr, v) { return Array.isArray(arr) && arr.indexOf(v) > -1; }
function paraFmt(n) {
  if (!n || n === 0) return '—';
  if (n >= 1000000) return (n / 1000000).toFixed(n % 1000000 === 0 ? 0 : 1) + ' Milyon ₺';
  if (n >= 1000)    return Math.round(n / 1000) + ' Bin ₺';
  return n + ' ₺';
}

/* ════════════════ STATE ════════════════ */
var adim     = 0;
var cevaplar = {};
var cok      = {};

/* ════════════════ ELEMENTLER ════════════════ */
var ekranIntro = document.getElementById('rmEkranIntro');
var ekranQuiz  = document.getElementById('rmEkranQuiz');
var ekranSonuc = document.getElementById('rmEkranSonuc');
var kart       = document.getElementById('rmKart');
var progressIc = document.getElementById('rmProgressIc');
var adimYazi   = document.getElementById('rmAdimYazi');
var geriBtn    = document.getElementById('rmGeri');

/* ════════════════ URL PARAMETRE OKUMA ════════════════ */
/* Motor Hero v3 mini quiz'den gelen cevapları yakalar  */
function urlParamOku() {
  try {
    var params   = new URLSearchParams(window.location.search);
    var deneyim  = params.get('deneyim');
    var butce    = params.get('butce');
    var kullanim = params.get('kullanim');
    var kategori = params.get('kategori');

    if (!deneyim && !butce && !kullanim && !kategori) return false;

    if (deneyim)  cevaplar.deneyim  = deneyim;
    if (butce)    cevaplar.butce    = parseInt(butce, 10) || 400000;
    if (kullanim) cevaplar.kullanim = kullanim.split(',').filter(Boolean);
    if (kategori) cevaplar.kategori = kategori.split(',').filter(Boolean);

    /* Mini quiz'de sorulmayan alanlar için makul varsayılanlar */
    if (!cevaplar.tarz)  cevaplar.tarz  = 'dengeli';
    if (!cevaplar.artci) cevaplar.artci = 'arasira';
    if (!cevaplar.takas) cevaplar.takas = 'hayir';
    if (!cevaplar.odeme) cevaplar.odeme = 'pesin';

    return true;
  } catch(e) { return false; }
}

/* ════════════════ EKRAN GEÇİŞİ ════════════════ */
function ekranGecis(kapat, ac, cb) {
  kapat.classList.add('rm-ekran--cikis');
  setTimeout(function() {
    kapat.classList.remove('rm-ekran--cikis');
    kapat.hidden = true;
    ac.hidden = false;
    ac.classList.add('rm-ekran--giris');
    setTimeout(function() {
      ac.classList.remove('rm-ekran--giris');
      if (cb) cb();
    }, 350);
  }, 240);
}

/* ════════════════ SAYFA YÜKLENINCE URL KONTROLÜ ════════════════ */
(function() {
  if (urlParamOku()) {
    /* Parametreler geldi → intro'yu atla, direkt sonuç göster */
    ekranIntro.hidden = true;
    ekranSonuc.hidden = false;
    profilRender();
    motorlarRender();
    /* URL'i temizle (tarayıcı geçmişi bozulmasın) */
    if (window.history && window.history.replaceState) {
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }
})();

/* ════════════════ BAŞLAT BUTONU ════════════════ */
document.getElementById('rmBaslat').addEventListener('click', function() {
  ekranGecis(ekranIntro, ekranQuiz, function() { soruGoster(0); });
});

/* ════════════════ SORU GÖSTER ════════════════ */
function soruGoster(i) {
  var s = SORULAR[i];
  adimYazi.textContent = (i + 1) + ' / ' + SORULAR.length;
  progressIc.style.width = Math.round((i / SORULAR.length) * 100) + '%';
  geriBtn.hidden = i === 0;

  kart.classList.add('rm-slide-cik');
  setTimeout(function() {
    kart.innerHTML = kartHTML(s, i);
    kart.classList.remove('rm-slide-cik');
    kart.classList.add('rm-slide-gir');
    void kart.offsetWidth;
    kart.classList.remove('rm-slide-gir');
    olaylarBagla(s, i);
  }, 200);
}

/* ════════════════ KART HTML ════════════════ */
function kartHTML(s, i) {
  var h = '<div class="rm-soru-ust">';
  h += '<div class="rm-soru-no">Soru ' + (i + 1) + '</div>';
  h += '<h3 class="rm-soru-metin">' + s.metin + '</h3>';
  if (s.ipucu) h += '<p class="rm-soru-ipucu">' + s.ipucu + '</p>';
  h += '</div>';

  if (s.tip === 'tek' || s.tip === 'cok') {
    var kolClass = 'rm-secenekler--' + (s.kol || 1);
    h += '<div class="rm-secenekler ' + kolClass + '">';
    for (var j = 0; j < s.secenekler.length; j++) {
      var sec = s.secenekler[j];
      var aktif = s.tip === 'cok' ? includes(cok[s.id], sec.v) : cevaplar[s.id] === sec.v;
      h += '<button type="button" class="rm-sec' + (aktif ? ' rm-sec--aktif' : '') + '" data-v="' + sec.v + '">';
      h += '<span class="rm-sec__ikon">' + (SVG[sec.ikonKey] || '') + '</span>';
      h += '<span class="rm-sec__bilgi">';
      h += '<span class="rm-sec__etiket">' + sec.etiket + '</span>';
      if (sec.alt) h += '<span class="rm-sec__alt">' + sec.alt + '</span>';
      h += '</span>';
      h += '<span class="rm-sec__kutu">' + SVG.check + '</span>';
      h += '</button>';
    }
    h += '</div>';
    if (s.tip === 'cok') {
      var dis = (!cok[s.id] || !cok[s.id].length) ? ' disabled' : '';
      h += '<div class="rm-devam-alan"><button type="button" class="rm-devam-btn" id="rmDevamBtn"' + dis + '>';
      h += '<span>Devam Et</span>' + SVG.chevron + '</button></div>';
    }
  }

  if (s.tip === 'slider') {
    var bv = cevaplar[s.id] !== undefined ? cevaplar[s.id] : s.varsayilan;
    h += '<div class="rm-slider-alan">';
    h += '<div class="rm-slider-gosterge"><span class="rm-slider-rakam" id="rmSliderRakam">' + paraFmt(bv) + '</span></div>';
    h += '<input class="rm-slider" id="rmSliderInput" type="range" min="' + s.min + '" max="' + s.max + '" step="' + s.adim + '" value="' + bv + '">';
    h += '<div class="rm-slider-aralik"><span>' + paraFmt(s.min) + '</span><span>' + paraFmt(s.max) + '</span></div>';
    h += '</div>';
    h += '<div class="rm-devam-alan"><button type="button" class="rm-devam-btn" id="rmDevamBtn">';
    h += '<span>Devam Et</span>' + SVG.chevron + '</button></div>';
  }
  return h;
}

/* ════════════════ OLAYLAR ════════════════ */
function olaylarBagla(s, i) {
  if (s.tip === 'tek') {
    kart.querySelectorAll('.rm-sec').forEach(function(btn) {
      btn.addEventListener('click', function() {
        kart.querySelectorAll('.rm-sec').forEach(function(b) { b.classList.remove('rm-sec--aktif'); });
        btn.classList.add('rm-sec--aktif');
        cevaplar[s.id] = btn.dataset.v;
        setTimeout(function() { ileri(i); }, 280);
      });
    });
  }
  if (s.tip === 'cok') {
    if (!cok[s.id]) cok[s.id] = [];
    kart.querySelectorAll('.rm-sec').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var v = btn.dataset.v;
        var idx = cok[s.id].indexOf(v);
        if (idx > -1) { cok[s.id].splice(idx, 1); btn.classList.remove('rm-sec--aktif'); }
        else { cok[s.id].push(v); btn.classList.add('rm-sec--aktif'); }
        var db = document.getElementById('rmDevamBtn');
        if (db) db.disabled = cok[s.id].length === 0;
      });
    });
    var db2 = document.getElementById('rmDevamBtn');
    if (db2) db2.addEventListener('click', function() { cevaplar[s.id] = cok[s.id].slice(); ileri(i); });
  }
  if (s.tip === 'slider') {
    var sldr = document.getElementById('rmSliderInput');
    var rkm  = document.getElementById('rmSliderRakam');
    if (sldr) {
      sldr.addEventListener('input', function() {
        if (rkm) {
          rkm.textContent = paraFmt(parseInt(sldr.value, 10));
          rkm.classList.add('zipladi');
          setTimeout(function() { rkm.classList.remove('zipladi'); }, 120);
        }
      });
    }
    var db4 = document.getElementById('rmDevamBtn');
    if (db4) db4.addEventListener('click', function() {
      cevaplar[s.id] = parseInt(sldr ? sldr.value : s.varsayilan, 10);
      ileri(i);
    });
  }
}

/* ════════════════ NAVİGASYON ════════════════ */
function ileri(i) {
  var sonraki = i + 1;
  if (sonraki >= SORULAR.length) { sonucGoster(); return; }
  adim = sonraki;
  soruGoster(sonraki);
}
geriBtn.addEventListener('click', function() {
  if (adim <= 0) return;
  adim--;
  soruGoster(adim);
});

/* ════════════════ SONUÇ ════════════════ */
function sonucGoster() {
  progressIc.style.width = '100%';
  ekranGecis(ekranQuiz, ekranSonuc, function() {
    profilRender();
    motorlarRender();
  });
}

function profilRender() {
  var el = document.getElementById('rmSonucProfil');
  if (!el) return;
  var chip = [];
  var dMap = { baslangic: 'Başlangıç', orta: 'Orta Seviye', ileri: 'İleri Seviye' };
  var tMap = { konforlu: 'Konforlu', agresif: 'Agresif', dengeli: 'Dengeli', sportif: 'Sportif' };
  if (cevaplar.deneyim)               chip.push({ svg: SVG.deneyim, txt: dMap[cevaplar.deneyim] || cevaplar.deneyim });
  if (cevaplar.tarz)                  chip.push({ svg: SVG.tarz,    txt: tMap[cevaplar.tarz]    || cevaplar.tarz });
  if (cevaplar.butce)                 chip.push({ svg: SVG.butce,   txt: paraFmt(cevaplar.butce) });
  if (cevaplar.takas === 'evet')      chip.push({ svg: SVG.takas,   txt: 'Takas Kabul' });
  if (cevaplar.kategori && cevaplar.kategori.length) {
    chip.push({ svg: SVG.motor, txt: cevaplar.kategori.join(', ') });
  }
  el.className = 'rm-profil';
  el.innerHTML = chip.map(function(c) {
    return '<span class="rm-profil__chip">' + c.svg + ' ' + c.txt + '</span>';
  }).join('');

  /* Sonuç alt yazısını güncelle */
  var altEl = document.getElementById('rmSonucAlt');
  if (altEl) {
    var minideneyim = dMap[cevaplar.deneyim] ? ' · ' + dMap[cevaplar.deneyim] : '';
    altEl.textContent = 'Stoğumuzdan profiline en uyumlu motosikletler listeleniyor' + minideneyim + '.';
  }
}

function motorlarRender() {
  var liste = document.getElementById('rmSonucListe');
  if (!liste) return;

  if (URUNLER.length === 0) {
    liste.innerHTML = '<div class="rm-bos">' + SVG.noResult +
      '<div class="rm-bos__baslik">İlan bulunamadı</div>' +
      '<div class="rm-bos__alt">Henüz stokta ürün yok.</div></div>';
    return;
  }

  var skorlu = URUNLER.map(function(u) {
    return { u: u, s: urunPuanla(u, cevaplar) };
  });
  skorlu.sort(function(a, b) { return b.s - a.s; });
  var goster = skorlu.slice(0, 5);

  liste.innerHTML = goster.map(function(item, idx) {
    return ilanKartHTML(item.u, item.s, idx);
  }).join('');

  /* Gauge animasyonu */
  setTimeout(function() {
    liste.querySelectorAll('.rm-gauge__dolu').forEach(function(el) {
      var h = parseFloat(el.dataset.h);
      el.style.strokeDashoffset = 188.5 - (188.5 * h / 100);
    });
  }, 80);
}

function ilanKartHTML(u, skor, idx) {
  var gaugeRenk = skor >= 82 ? 'rm-gauge__dolu--yesil' : (skor >= 65 ? 'rm-gauge__dolu--kirmizi' : 'rm-gauge__dolu--turuncu');
  var delay = (idx * 0.1) + 's';

  var etiketler = [];
  if (u.kategori)       etiketler.push({ l: u.kategori,        r: 'b' });
  if (u.durum)          etiketler.push({ l: u.durum,           r: 'y' });
  if (u.mensei)         etiketler.push({ l: u.mensei,          r: 'g' });
  if (u.hasar_kayitsiz) etiketler.push({ l: 'Hasar Kayıtsız',  r: 'y' });
  if (u.takas_olur)     etiketler.push({ l: 'Takas Olur',      r: 't' });

  var etiketH = etiketler.map(function(e) {
    return '<span class="rm-motor__etiket rm-motor__etiket--' + e.r + '">' + e.l + '</span>';
  }).join('');

  var resimH = u.resim
    ? '<img class="rm-motor__resim" src="' + u.resim + '" alt="' + u.baslik + '" loading="lazy">'
    : '<div class="rm-motor__resim-yok">' + SVG.motor + '</div>';

  var specs = [];
  if (u.yil)         specs.push({ svg: SVG.yil,      label: 'Model Yılı',  value: u.yil });
  if (u.kilometre)   specs.push({ svg: SVG.km,       label: 'Kilometre',   value: u.kilometre + ' km' });
  if (u.motor_hacmi) specs.push({ svg: SVG.cc,       label: 'Motor Hacmi', value: u.motor_hacmi + ' cc' });
  if (u.motor_gucu)  specs.push({ svg: SVG.hiz,      label: 'Motor Gücü',  value: u.motor_gucu });
  if (u.vites)       specs.push({ svg: SVG.vites,    label: 'Vites',       value: u.vites });
  if (u.sogutma)     specs.push({ svg: SVG.motor,    label: 'Soğutma',     value: u.sogutma });
  if (u.silindir)    specs.push({ svg: SVG.motor,    label: 'Silindir',    value: u.silindir });
  if (u.lokasyon)    specs.push({ svg: SVG.lokasyon, label: 'Lokasyon',    value: u.lokasyon });

  var specsH = specs.map(function(sp) {
    return '<div class="rm-spec">' +
      '<div class="rm-spec__label">' + sp.svg + ' ' + sp.label + '</div>' +
      '<div class="rm-spec__value">' + sp.value + '</div>' +
      '</div>';
  }).join('');

  var odemeH = '';
  if (u.taksit_12ay) odemeH += '<span class="rm-motor__odeme-chip">' + SVG.cc + ' 12 Ay: ' + paraFmt(parseFloat(u.taksit_12ay)) + '/ay</span>';
  else if (u.taksit_6ay) odemeH += '<span class="rm-motor__odeme-chip">' + SVG.cc + ' 6 Ay: ' + paraFmt(parseFloat(u.taksit_6ay)) + '/ay</span>';

  var ekstraH = '';
  if (u.ekstralar && u.ekstralar.trim() !== '') {
    ekstraH = '<div class="rm-motor__ekstralar"><strong>Ekstralar & Notlar</strong>' + u.ekstralar + '</div>';
  }

  return '<div class="rm-motor" style="animation-delay:' + delay + '">' +
    '<div class="rm-motor__ust">' +
      resimH +
      '<div class="rm-motor__bilgi">' +
        '<div class="rm-motor__bilgi-ust">' +
          '<div class="rm-motor__marka">' + (u.marka || '') + '</div>' +
          '<div class="rm-motor__isim">' + u.baslik + '</div>' +
          '<div class="rm-motor__etiketler">' + etiketH + '</div>' +
        '</div>' +
        '<div class="rm-motor__fiyat-alan">' +
          '<div class="rm-motor__fiyat">' + paraFmt(u.fiyat) + '</div>' +
          odemeH +
        '</div>' +
      '</div>' +
      '<div class="rm-motor__gauge-alan">' +
        '<div class="rm-gauge">' +
          '<svg width="70" height="70" viewBox="0 0 70 70">' +
            '<circle class="rm-gauge__iz" cx="35" cy="35" r="30"/>' +
            '<circle class="rm-gauge__dolu ' + gaugeRenk + '" cx="35" cy="35" r="30" data-h="' + skor + '"/>' +
          '</svg>' +
          '<div class="rm-gauge__yazi">%' + skor + '</div>' +
        '</div>' +
        '<div class="rm-gauge__label">Uyum</div>' +
      '</div>' +
    '</div>' +
    '<div class="rm-motor__icerik">' +
      (specsH ? '<div class="rm-motor__specs">' + specsH + '</div>' : '') +
      ekstraH +
      '<div class="rm-motor__footer">' +
        (u.telefon ? '<div class="rm-motor__iletisim">' + SVG.telefon + ' ' + u.telefon + '</div>' : '<div></div>') +
        '<a href="' + u.url + '" class="rm-motor__incele-btn">İlanı İncele ' + SVG.chevron + '</a>' +
      '</div>' +
    '</div>' +
  '</div>';
}

/* ════════════════ YENİLE ════════════════ */
document.getElementById('rmYenile').addEventListener('click', function() {
  cevaplar = {}; cok = {}; adim = 0;
  progressIc.style.width = '0%';
  ekranGecis(ekranSonuc, ekranIntro);
});

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
(function () {
  /* ── GÖRÜNÜM TOGGLE ── */
  var gridWrap = document.getElementById('ilGrid-wrap');
  var btnGrid  = document.getElementById('ilGrid');
  var btnListe = document.getElementById('ilListe');
  if (gridWrap && btnGrid && btnListe) {
    if (localStorage.getItem('ilGorunum') === 'liste') {
      gridWrap.classList.add('liste-mod');
      btnListe.classList.add('aktif');
      btnGrid.classList.remove('aktif');
    }
    btnGrid.addEventListener('click', function () {
      gridWrap.classList.remove('liste-mod');
      btnGrid.classList.add('aktif');
      btnListe.classList.remove('aktif');
      localStorage.setItem('ilGorunum', 'grid');
    });
    btnListe.addEventListener('click', function () {
      gridWrap.classList.add('liste-mod');
      btnListe.classList.add('aktif');
      btnGrid.classList.remove('aktif');
      localStorage.setItem('ilGorunum', 'liste');
    });
  }

  /* ── KARŞILAŞTIRMA ── */
  var KARS_KEY   = 'mfKarsilastirma';
  var KARS_MAX   = 4;
  var KARS_EVENT = 'mf:karsilastirma-guncellendi';

  function karsListesiAl() {
    try { return JSON.parse(localStorage.getItem(KARS_KEY)) || []; }
    catch (e) { return []; }
  }
  function karsListesiYaz(liste) {
    localStorage.setItem(KARS_KEY, JSON.stringify(liste));
    document.dispatchEvent(new CustomEvent(KARS_EVENT));
  }
  function karsBtnDurumGuncelle(btn, aktif) {
    btn.classList.toggle('aktif', aktif);
    btn.setAttribute('aria-pressed', aktif ? 'true' : 'false');
    btn.title = aktif ? 'Karşılaştırmadan çıkar' : 'Karşılaştırmaya ekle';
  }
  function karsKartlariSenkronize() {
    var liste = karsListesiAl();
    document.querySelectorAll('.il-kart__kars-btn').forEach(function (btn) {
      var id = btn.getAttribute('data-id');
      karsBtnDurumGuncelle(btn, liste.some(function (u) { return u.id === id; }));
    });
  }
  karsKartlariSenkronize();
  document.addEventListener(KARS_EVENT, karsKartlariSenkronize);

  if (gridWrap) {
    gridWrap.addEventListener('click', function (e) {
      var btn = e.target.closest('.il-kart__kars-btn');
      if (!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-id');
      var liste = karsListesiAl();
      var index = liste.findIndex(function (u) { return u.id === id; });
      if (index > -1) {
        liste.splice(index, 1);
        karsListesiYaz(liste);
      } else {
        if (liste.length >= KARS_MAX) {
          alert('En fazla ' + KARS_MAX + ' ilanı karşılaştırabilirsiniz.');
          return;
        }
        liste.push({
          id: id,
          title: btn.getAttribute('data-title'),
          url: btn.getAttribute('data-url'),
          image: btn.getAttribute('data-image'),
          price: btn.getAttribute('data-price'),
          marka: btn.getAttribute('data-marka'),
          model: btn.getAttribute('data-model'),
          yil: btn.getAttribute('data-yil'),
          km: btn.getAttribute('data-km'),
          hacim: btn.getAttribute('data-hacim'),
          vites: btn.getAttribute('data-vites'),
          durum: btn.getAttribute('data-durum')
        });
        karsListesiYaz(liste);
      }
    });
  }

  /* ── SONSUZ KAYDIRMA ── */
  var sayfalamaBolge = document.getElementById('ilSayfalamaBolge');
  var sentinel       = document.getElementById('ilScrollSentinel');
  var loader         = document.getElementById('ilScrollLoader');

  if (gridWrap && sayfalamaBolge && sentinel && loader && gridWrap.getAttribute('data-sonsuz') === 'true') {
    var sectionId  = gridWrap.getAttribute('data-section-id');
    var yukleniyor = false;
    var bitti      = false;

    sayfalamaBolge.classList.add('il-sayfalama-bolge--gizli');

    function ilYukleDahaFazla() {
      var nextUrl = sayfalamaBolge.getAttribute('data-next-url');
      if (!nextUrl || yukleniyor || bitti) return;
      yukleniyor = true;
      loader.hidden = false;

      var ayrac = nextUrl.indexOf('?') > -1 ? '&' : '?';
      fetch(nextUrl + ayrac + 'section_id=' + sectionId)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var dom = new DOMParser().parseFromString(html, 'text/html');
          var yeniGrid = dom.getElementById('ilGrid-wrap');
          if (yeniGrid) {
            yeniGrid.querySelectorAll('.il-kart').forEach(function (kart) {
              gridWrap.appendChild(kart);
            });
            karsKartlariSenkronize();
          }
          var yeniBolge = dom.getElementById('ilSayfalamaBolge');
          var yeniNext  = yeniBolge ? yeniBolge.getAttribute('data-next-url') : '';
          if (yeniNext) {
            sayfalamaBolge.setAttribute('data-next-url', yeniNext);
          } else {
            bitti = true;
            gozlemci.disconnect();
          }
        })
        .catch(function () { /* sonraki scroll'da tekrar dener */ })
        .finally(function () {
          yukleniyor = false;
          loader.hidden = true;
        });
    }

    var gozlemci = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) ilYukleDahaFazla();
      });
    }, { rootMargin: '600px 0px 0px 0px' });

    gozlemci.observe(sentinel);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
